module.exports = __webpack_public_path__ + "newWebTMS/img/search-icon.166ae9a1.svg";